import { MainLayout } from '~/components';
import { useEffect } from 'react';
// import { Grid } from "@material-ui/core";
import Grid from '@mui/material/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Heropagebg } from '~/assets';
import { Header } from '../../components/MainLayout/Header';
import Typography from '@mui/material/Typography';
import { css } from 'styled-components';
import Box, { BoxProps } from '@material-ui/core/Box';
import { SpacedHeading, TypographyH1, Button } from '../../components';
import { Twitterlogo } from '~/assets';
import { MLogo } from '~/assets';
import { Smilylogo } from '~/assets';
import { Telegramlogo } from '~/assets';
import { LineImg } from '~/assets';
import { backgroundImage } from '~/assets';
import { styled } from '@mui/material/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import mobileBG from '../../assets/svgs/mobileBG.png'
import pdf from '../../assets/whitepaper.pdf'
import {RightArrow} from '~/assets'

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    marginTop: '220px',
    marginRight: '15px',
    marginLeft: '15px',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row',
    margin: 'auto',
    marginTop: '420px',
    marginRight: '40px',
    marginLeft: '40px',
  },
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    flexDirection: 'row',
    margin: 'auto',
    marginTop: '420px',
    marginRight: '40px',
    marginLeft: '40px',
  },
}));

// const MuiCustomBreakPoints = createMuiTheme({
//   breakpoints: {
//     values: {
//       xs: 0,
//       sm: 576,
//       md: 768,
//       lg: 1024,
//       xl: 1200,
//     },
//   },
// });

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${mobileBG})`,
    backgroundRepeat: 'no-repeat',
    // marginTop: "-0px",
    [theme.breakpoints.up('sm')]:{
      backgroundSize:"100% auto", 
      backgroundPosition:"center top",
      backgroundImage: `url(${backgroundImage})`,
      
    },
    [theme.breakpoints.up('xl')]:{
      backgroundSize:"100% auto", 
      backgroundPosition:"100% 10%",
      
    },
    backgroundSize:"100%",
  },
  lineImg: {
    transform: "rotate(270deg)",
    [theme.breakpoints.up('md')]:{ transform: "rotate(0deg)"},
  },
  icon:{
    marginRight: 20, 
    position: 'static',
    width:'19px',
    [theme.breakpoints.up('md')]:{width:'24px', marginRight:32}
  },
  button:{
    height: '38px',
    borderRadius: '10px',
    [theme.breakpoints.up('md')]:{height:'48px', borderRadius:'8px'}
  },
  content:{
    marginTop:'175px',
    [theme.breakpoints.up('md')]:{marginTop:'280px'},
    [theme.breakpoints.up('lg')]:{marginTop:'480px'},
    [theme.breakpoints.up('xl')]:{marginTop:'650px'},
    [theme.breakpoints.up(2400)]:{marginTop:'950px'},

  }, 
  para:{
    marginTop: 20,
    [theme.breakpoints.up('lg')]: {marginTop: 0}
  }
  
}));

export const HeroPage = () => {
  const classes = useStyles();
  return (
    <Box className={classes.root} width="100%" align-item="center" id="home" display="flex" justifyContent="center" flexDirection="column">
      <Box display="flex" justifyContent="center" flexDirection="column" alignItems='center'>
        <Box
          display="flex"
          justifyContent="center"
          alignItems='center'
          flexDirection={{ xs: 'column', lg: 'row' }}
          marginX={{xs:2}}
        >
          <Box
            width="100%"
            maxWidth="999px"
            display="flex"
            color="black"
            flexDirection="column"
            alignItems="center"
            marginTop={{ xs: 12, lg: 17, xl:'20%' }}
            
          >
            <Typography
              style={{
                // color: '#F69501',
                textTransform: 'uppercase',
                opacity: '0.75'
              }}
              fontWeight="600"
              lineHeight={{xs: '16px', lg: '26px'}}
              variant="body2"
              textAlign='center'
              letterSpacing={{xs: '0.25rem', lg: '0.5rem'}}
              fontSize={{xs:'11px', lg:'14px'}}
              color='#ffffff'
              
            >
              Get on board with skillsbite
            </Typography>
            <Typography
              style={{
                fontFamily: 'Poppins',
                marginTop: '11px',
                fontWeight: 600,
                color: "#fff",
                textAlign: "center",
                wordBreak: "break-word",
                letterSpacing: "0px",
                lineHeight:"110%"
              }}
              fontSize={{xs: '32px', lg: '52px'}}
            >
              First ever expanding gamified learning ecosystem with its own
              universe
            </Typography>
            <Box
              display="flex"
              flexDirection="row"
              // width="500px"
              justifyContent="center"
              alignItems='center'
              // alignItems="flex-start"
              sx={{ marginTop: 50 }}
            >
              <a href="https://twitter.com/skillsbite_io ">
              <img
                className={classes.icon}
                src={Twitterlogo}
              ></img>
              </a>
              <a href="https://t.me/+kMI8FcH5Wsg4YTJk ">
                <img
                  className={classes.icon}
                  src={Telegramlogo}
                ></img>
              </a>
              <a href="https://medium.com/@skillsbite">
                <img
                  className={classes.icon}
                  src={MLogo}
                ></img>
              </a>

              <a href="https://discord.gg/nPpV56Rsg4 ">
                <img
                  className={classes.icon}
                  src={Smilylogo}
                ></img>
              </a>
            </Box>
          </Box>
        </Box>

        {/* <Root> */}
        <Box
          display="flex"
          maxWidth="1400px"
          flexDirection={{ xs: 'column', md: 'column', lg: 'row' }}
          marginX={{ xs: 2, lg: 10 }}
          paddingY={{ xs: 5, lg: 10 }}
          paddingX={{ xs: 2, lg: 10 }}
          style={{
            backgroundColor: '#141420',
          }}
          justifyContent="center"
          borderRadius='8px'
          className={classes.content}
          // alignItems="center"
        >
          <Box
            display="flex"
            flexDirection={{xs:"column", md: "row"}}
            // width="50%"
            // margin={{ lg: "0px 50px 0px 0px", xs: "30px 0 0 0" }}
          >
            <Box
              justifyContent="flex-end"
              alignItems="flex-start"
              width="fit-content"
              marginTop= {{xs: "-100px", md:"0px"}}
              marginBottom= {{xs: "-50px", md:"0px"}}
              marginLeft= {{xs: "50px", md:"0px"}}
              // width="60%"
              // height="100%"
              className={classes.lineImg}
            >
              <img src={LineImg}></img>
            </Box>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems={{ xs: "start", md: "start", lg: "start" }}
            >
              <Typography variant="h6" fontSize={{xs:'20px', md:'40px'}} lineHeight='110%' paddingX={{ xs: 0, lg: 5 }}>
                The right way to learn online
              </Typography>
            </Box>
          </Box>
          <Box
            className={classes.para}
            display="flex"
            flexDirection="column"
            width={{lg: "100%"}}
            // position="sticky"
            // margin={{ lg: "0px 50px 0px 10px", xs: "30px 12px 0 12px" }}
            paddingX={{ lg: 5 }}
            style={{
              backgroundColor: 'transparent',
            }}
          >
            <Typography textAlign={{xs: 'start', lg: 'start'}} fontSize={{xs:'16px', md:'16px'}} lineHeight={{xs:'26px', md:'28px'}} paragraph variant="body2">
              Skillsbite is a unique platform that opens space for the knowledge
              creation and the use of various learning methods to fulfil
              expectations and needs of every learner around the world. 
              
              Skillsbite ecosystem is built around an idea of universe with
              similar characteristics to knowledge. It represents a world with
              endless possibilities, new learning opportunities and captivating
              secrets. 
              
              By enabling interactions between learners, mentors, educators and
              content creators skillsbite’s platform facilitates the creation of
              a multi-dimensional network of like-minded individuals.
            </Typography>
            <Typography
              paragraph
              // style={{
              //   fontFamily: 'Poppins',
              //   marginTop: '15px',
              //   color: '#fff',
              //   fontSize: '16px',
              //   wordBreak: 'break-word',
              //   letterSpacing: '0px',
              //   lineHeight: '28px',
              // }}
              variant="body2"
              fontSize="16px"
            >
              Read the whitepaper to learn more
            </Typography>
            <Box
              style={{
                alignItems: 'center',
                justifyContent: 'flex-start',
                display: 'flex',
                borderRadius: '7px',
                // backgroundColor: "#fff",
                color: '#000',
                marginBottom: 20,
              }}
            >
              <a style={{textDecoration:"none"}} href={pdf} target='_blank' rel='noreferrer'>
              <Button variant='contained' className={classes.button}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  pr={2}
                  pl={2}
                >
                  <Box>
                    <Typography
                      style={{
                        fontFamily: 'Poppins',
                        color: '#000000',
                        fontSize: '13px',
                        fontWeight: 500,
                        textDecoration:"none"
                      }}
                    >
                      WhitePaper
                    </Typography>
                  </Box>
                  <Box
                    // bgcolor="red"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    marginLeft={2}
                  >
                    <img src={RightArrow}></img>
                  </Box>
                </Box>
              </Button>
              </a>
            </Box>
          </Box>
        </Box>
        {/* </Root> */}
      </Box>
    </Box>
  );
};
